module.exports = __webpack_public_path__ + "img/more-offers-img.b5d7186a.png";